module.exports = __webpack_public_path__ + "img/circle-fill.24754219.png";